import './applied_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedGmbCitiesFilterView extends
      Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'gmb_cities'
  humanize: true
  unmodifiableByModerators: false

  initialize: ({searchQuery}) ->
    super({searchQuery: searchQuery})
    @alias = I18n.t('monitoring.dashboard.filters.gmb_cities')

  removeFilter: (value) ->
    @searchQuery.removeGmbCity(value)

  getDescription: (city) ->
    super(city)
